<template>
  <div class="container" style="margin-top: 112px; margin-bottom: 120px">
    <private-header-menu v-if="authUser._id && authUser._id !== null" />
    <header-menu v-else />
    <div class="row">
      <div
        class="mb-2"
        style="display: flex; align-items: center; justify-content: center"
      >
        <div style="text-align: center">
          <img
            src="./.././../assets/images/ivania-alvarado.jpeg"
            style="height: 400px"
            class="align-self-start mr-3 rounded-circle float-left"
            alt="..."
          />
          <h1 class="mt-2">Ivania Alvarado</h1>
          <p>
            (305) 401-4516 - reschool1999@gmail.com <br />
            <a href="https://www.linkedin.com/in/ivania-alvarado-07577825/">
              https://www.linkedin.com/in/ivania-alvarado-07577825</a
            >
            <br />
            Driven professional with 25+ years of real estate broker and manger
            experience
          </p>
        </div>
      </div>
      <hr />
      <h4 class="mt-3">SUMMARY OF QUALIFICATIONS</h4>
      <div class="row">
        <div class="col-12">
          Multitask, goal-oriented, real estate broker, and real estate
          instructor with a vast experience working with clients, agents, and
          staff. Extensive experience managing real estate, mortgage, and title
          companies as well as school of real estate. Helping sales associates
          to achieve their goals. Thru the years, programs were made for sales
          agents that includes mentorships, telemarketing, knocking doors, and
          pre-qualifying buyers.
          <ul>
            <li>Property Sales</li>
            <li>Sales Training and Leadership</li>
            <li>Prospecting</li>
            <li>Farming</li>
            <li>Operational Management</li>
            <li>Recruiting</li>
            <li>Rent/Leases</li>
            <li>Coaching/Mentoring/Consulting Agents</li>
            <li>Escrow/Titles</li>
            <li>Legal/Dispute Resolution</li>
            <li>Negotiation</li>
            <li>Strategy Decision Making</li>
            <li>Finance Analysis</li>
            <li>Office and File Compliance</li>
            <li>Network event coordinator</li>
            <li>Prequalifying Buyers</li>
            <li>Customer Service</li>
            <li>Team Meeting</li>
            <li>Telemarketing</li>
            <li>Door Knocking</li>
            <li>Managing, Payroll</li>
            <li>Property management</li>
            <li>Marketing</li>
            <li>FAR/BAR contracts</li>
            <li>Commissioning</li>
          </ul>
        </div>
      </div>

      <hr />

      <h4 class="mt-3">EDUCATION</h4>
      <div class="row">
        <div class="col-12">
          <strong>Florida Atlantic University </strong>, Davie, Florida August
          2023
          <p>Master of Taxation</p>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <strong>Miami Dade College </strong>, Miami, Florida July 2021
          <p>
            Bachelor of Supervision and Management- Accounting Concentration
          </p>
        </div>
      </div>

      <hr />

      <h4 class="mt-3">PROFESSIONAL EXPERIENCE</h4>
      <div class="row">
        <div class="col-12">
          <strong>Miami Dade College</strong>
          <p>
            Adjunct Faculty I, & Continuing Ed Instructor, May 2023 – Present
          </p>
          <ul>
            <li>
              Teach, prepare, and review exams for several classes (Real estate,
              QuickBooks, Tax1 & 2, Finance, Marketing, Sales, Property
              Management, and more.
            </li>
          </ul>
        </div>

        <div class="col-12">
          <strong>Miami Dade College and the IRS</strong>
          <p>
            VITA Preparer, February-April 2022, February-April 2023,
            February-April 2024 & February-April 2025
          </p>
          <ul>
            <li>
              Prepare, train, and review income tax returns, and file
              amendments.
            </li>
          </ul>
        </div>

        <div class="col-12">
          <strong>Lux Tax & Accounting, LLC</strong>
          <p>CEO, November 2023 - Present</p>
          <ul>
            <li>
              Prepare, train, and review income tax returns, and file
              amendments.
            </li>
          </ul>
        </div>

        <div class="col-12">
          <strong>Net Realty Services, Inc. </strong>
          <p>Real Estate Broker, January 2017 – Present</p>
          <ul>
            <li>Supervising agents’ transactions</li>
            <li>
              Answering agent’s general questions and conducting 1 productive
              training per month
            </li>
            <li>
              Recruiting agents to refer them to other brokerage companies.
            </li>
          </ul>
        </div>

        <div class="col-12">
          <strong>South Florida School of Real Estate, Inc.</strong>
          <p>Owner-Instructor February 1999 – Present</p>
          <ul>
            <li>Promoting the school to get new students.</li>
            <li>
              Creating new online courses, training, and services for agents,
              brokers, and students
            </li>
            <li>Sales training to achieve personal goals for students.</li>
            <li>
              Teaching multiple courses such as sales associate, broker
              pre-license, continuing education, and more
            </li>
          </ul>
        </div>

        <div class="col-12">
          <strong>One Stop Realty</strong>
          <p>Broker Associate January 2015 – December 2016</p>
          <ul>
            <li>
              Worked with sellers, landlords, tenants, and buyers in their
              transactions.
            </li>
            <li>
              Coordinated the whole transaction from beginning to close (Listing
              or Purchase)
            </li>
            <li>
              Conferred with lenders, title companies, and report inspections to
              ensure that all conditions were met before closing.
            </li>
          </ul>
        </div>

        <div class="col-12">
          <strong>South Florida Realty, Inc.</strong>
          <p>Real Estate Broker October 1996 – February 2012</p>
          <ul>
            <li>
              Principle broker in charge of 140-160 active agents, office staff,
              and supervised all transactions.
            </li>
            <li>
              Enrolled new agents daily and made sure to set their goals to
              achieve their sales desire.
            </li>
            <li>
              Coordinated and conducted regular weekly company training
              meetings.
            </li>
          </ul>
        </div>

        <div class="col-12">
          <strong>Bankers Choice</strong>
          <p>Loan Originator November 1997 – April 2002</p>
          <ul>
            <li>
              Evaluated mortgage options to help clients obtain financing.
            </li>
            <li>
              Trained loan originators on how to pre-qualify a buyer and find
              the right loan program.
            </li>
          </ul>
        </div>

        <div class="col-12">
          <strong>Imperial Title Company</strong>
          <p>Account Representative Manager August 2002 – March 2004</p>
          <ul>
            <li>
              Account representative in charge of promoting and getting new
              accounts such as mortgage and real estate companies.
            </li>
            <li>
              Transaction coordinator between the realtors/brokers and the title
              company staff.
            </li>
            <li>
              Send wire funds to banks, clients, mortgage and real estate
              companies, lenders, agents, court, liens, recordings, etc.
            </li>
            <li>Supervised 40 to 70 closed transaction per month.</li>
          </ul>
        </div>
      </div>

      <hr />

      <h4 class="mt-3">LICENSES AND CERTIFICATES</h4>
      <div class="row">
        <div class="col-12">
          <ul>
            <li>License Real Estate Broker, Florida</li>
            <li>License Real Estate Instructor, Florida</li>
            <li>Certificate in General Business from Miami Dade College</li>
            <li>Associate’s in Arts from Miami Dade College</li>
            <li>PTIN: P02487047</li>
            <li>Notary Public-State of Florida</li>
          </ul>
        </div>
      </div>

      <hr />

      <h4 class="mt-3">SKILLS</h4>

      <div class="row">
        <div class="col-12">
          <ul>
            <li><b>Language:</b> English and Spanish.</li>
            <li>
              <b>Software:</b> Microsoft Excel, Microsoft Word, PowerPoint.
            </li>
            <li>CMA, Cloud CMA</li>
            <li>iMAPP, Realist</li>
            <li>Matrix, Rapattoni</li>
            <li>PROXIO</li>
            <li>Form Simplicity, Far Bar Contracts</li>
            <li>RPR, Remine</li>
            <li>
              Mentorship, Tutoring, Consulting, Property Management, Marketing,
              Operational Management, Bookkeeping, Income Tax returns preparer,
              CCH, Bloomberg BNA, Nexis Uni, Westlaw, Checkpoint Edge,
              Professor, Author.
            </li>
            <li>DotLoop, and more</li>
          </ul>
        </div>
      </div>
    </div>

    <footer class="fixed-bottom container-fluid text-bg-light">
      <p class="text-center">
        South Florida School of Real Estate© 2023 • All Rights Reserved
        <span class="text-muted ml-4">v1.0.0</span>
      </p>
    </footer>
  </div>
</template>

<script>
import headerMenu from "./headerMenu";
import Vuex from "vuex";
import privateHeaderMenu from "../../components/app/headerMenu";
export default {
  name: "about-us",
  components: {
    "header-menu": headerMenu,
    "private-header-menu": privateHeaderMenu,
  },
  computed: {
    ...Vuex.mapState({
      authUser: (state) => state.auth.user,
    }),
  },
};
</script>
